import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

function Map() {
    const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

    return (
        <div className="map fix" style={{ background: "#f5f5f5" }}>
            <div className="container-flud">
                <div className="row">
                    <div className="col-lg-12">
                        <motion.div
                            ref={ref}
                            initial={{ opacity: 0, y: 40, scale: 0.98 }}
                            animate={inView ? { opacity: 1, y: 0, scale: 1 } : {}}
                            transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
                            style={{ overflow: 'hidden', width: '100%' }}
                        >
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3438.832487420102!2d77.70460537449476!3d13.234234987105728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1d3f30d33c6d%3A0x219e2b323ad7bdf!2sAkash%20Institute%20of%20Pharmacy!5e1!3m2!1sen!2sin!4v1774767268087!5m2!1sen!2sin"
                                width={600}
                                height={450}
                                style={{ border: 0, display: 'block', width: '100%' }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Map;
